<template>
  <div class="resign-action">
    <!-- Resign button -->
    <button
      v-if="!showResignConfirm"
      class="button is-danger is-outlined"
      @click="showResignConfirm = true"
    >
      Resign
    </button>

    <!-- Resign Confirmation -->
    <div v-else class="user-actions__confirm">
      <button class="button is-outlined" @click="showResignConfirm = false">
        <span class="icon is-large">
          <i class="fa fa-times"></i>
        </span>
      </button>
      <button
        class="button is-danger is-outlined"
        @click="
          () => {
            showResignConfirm = false;
            this.$emit('onResign');
          }
        "
      >
        <span class="icon is-large">
          <i class="far fa-flag"></i>
        </span>
      </button>
      <div class="button is-static is-danger is-light">
        Resign
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Resign",

  data() {
    return {
      showResignConfirm: false,
    };
  },
};
</script>
<style scoped></style>
